import {FallcoClass} from "../classes/FallcoClass";
import "paginationjs";

/**
 * Classe che gestisce la paginazione dei dati contenuti in una tabella.
 * Crea sotto l'oggetto designato i pulsanti necessari per la paginazione e gli associa i leti eventi.
 *
 * Questa classe utilizza la librerira "Pagination.js", quindi assicurarsi di includere quest'ultima prima di usare
 * questa classe.
 *
 * Al momento la classe esegue cambi pagina in modo sincrono inducendo il refresh della pagina, ma se implementato
 * correttamente, la libreria Pagination.js permette di gestire la paginazione anche tramite chiamate Ajax.
 */
class Pagination extends FallcoClass{
  constructor() {
    super();

    this._settings = {
      pages_size_attribute : "fw-pagination-size",
      total_pages_attribute: "fw-pagination-total",
      total_found_attribute: "fw-pagination-total",
      page_number_attribute: "fw-pagination-page",
      pages_size           : 30
    };

    window.addEventListener("DOMContentLoaded", () => this._on_load());

    return super.expose_to_public("pagination", this)
  }

  /**
   * Evento al caricamento della pagina principale.
   * Inizializza da subito la libreria ed aggiunge un evento in ascolto per l'apertura dei modali, cos� da inizializzarla anche su questi.
   */
  _on_load() {

    this.init_pagination();

    $(document).on("loaded.modal.helper", (event, modal_popup) => {
      setTimeout(() => this.init_pagination(modal_popup.$modal));
      // nel modale controlliamo se abbiamo il parametro tab_active nell'url
      let urlModal = modal_popup.url.location_obj.toString();
      if(urlModal.includes('active_tab') && modal_popup.initialParms.titolo === 'Elenco errori import'){
        let idActiveTab = modal_popup.url.get_parameter_by_name('active_tab');
        $('[href="#'+idActiveTab+'"]').tab('show')
      }
    });
  }

  /**
   * Attiva la paginazione su cercando in tutta la pagina.
   * Se viene passato un elemento come parametro, attiva la paginazione cercando dentro all'elemento stesso.
   *
   * @param {HTMLElement | jQuery} [target]
   */
  init_pagination(target) {
    let elements;

    if (target) {
      if (!(target instanceof jQuery)) {
        target = $(target);
      }

      elements = target.find("[" + this._settings.total_pages_attribute + "]");
    } else {
      elements = $("[" + this._settings.total_pages_attribute + "]");
    }

    // Se l'utente tenta di usare questa libreria, controlla le dipendenze.
    if (elements.length > 0 && !$.pagination) {
      console.error("Per il funzionamento della paginazione � necessaria la librerira \"Pagination.js\"");
    }

    elements.map((i, _element) => {
      let element    = $(_element);
      let page_numer = element.attr(this._settings.page_number_attribute); // Cerca di leggere il numero della pagina dall'attributo "fw-pagination-page"
      let data       = {
        p_size: Number(element.attr(this._settings.pages_size_attribute)) || this._settings.pages_size,
        total : Number(element.attr(this._settings.total_found_attribute)) || 0,
      };

      if (data.total <= data.p_size) {
        return;
      }

      //  Se non viene specificata una pagina, la legge dall'url.
      if (!page_numer) {
        if (this._work_in_modal(element)) {
          let modal_obj = this._get_working_modal(element, true);
          page_numer    = modal_obj.url.get_parameter_by_name("page");
        } else {
          page_numer = $.helper.url.get_parameter_by_name("page")
        }
      }

      element.pagination({
        dataSource     : function (done) {
          // Imposta il dataSource creando un array vuota cos� che carichi il giusto numero di pagine.
          let data_source = new Array(data.total);

          done(data_source);
        },
        pageSize       : data.p_size,
        cache          : false,
        className      : "text-center",
        totalNumber    : data.total,
        pageNumber     : page_numer,
        ulClassName    : "pagination",
        prevText       : "<svg xmlns=\"http://www.w3.org/2000/svg\" height='27px' viewBox=\"0 0 192 512\"><path d=\"M192 127.3v257.3c0 17.8-21.5 26.7-34.1 14.1L29.2 270.1c-7.8-7.8-7.8-20.5 0-28.3l128.7-128.7c12.6-12.6 34.1-3.7 34.1 14.1z\"/></svg>",
        nextText       : "<svg xmlns=\"http://www.w3.org/2000/svg\" height='27px' viewBox=\"0 0 192 512\"><path d=\"M0 384.7V127.3c0-17.8 21.5-26.7 34.1-14.1l128.7 128.7c7.8 7.8 7.8 20.5 0 28.3L34.1 398.8C21.5 411.4 0 402.5 0 384.7z\"/></svg>",
        paginateAction : "?page",
        showGoInput    : true,
        showPageNumbers: false,
        alias          : {
          pageNumber: 'page'
        },
        callback       : (data, pagination) => this._on_page_change(data, pagination, element),
        beforeInit     : () => this._before_pagination_init(element),
        afterInit      : pagination => this._on_pagination_init(pagination, element),
      })
    })
  }

  /**
   * Evento chiamato prima che la paginazione venga inizializzata.
   * Controlla se l'attributo "fw-pagination-size" � stato settato o meno.
   * Se non � stato settato, mostra un avviso all'utente che lo invita a settarlo.
   * @param {jQuery} element
   */
  _before_pagination_init(element) {
    if (!element.attr("fw-pagination-size")) {
      let alert = $("<div class='alert alert-danger'>");
      alert.html("A causa di un errore la paginazione non pu&ograve; essere creata. ");

      element.after(alert);

      return false;
    }
  }

  /**
   * Evento chiamato dopo che Pagination viene aggiunto ad un elemento.
   * Sistema la posizione dei pulsanti relativi alle pagine.
   *
   * @param {Object} pagination
   * @param {jQuery} element
   */
  _on_pagination_init(pagination, element) {
    let type = element.prop("localName");

    element.addHook('afterPaging', () => {
      this._set_pagination_style(element, pagination)
    });


    this._set_pagination_style(element, pagination);

    if (type === "table") {
      pagination.wrap("<tr class='pagination-row'><td colspan='999'></td></tr>");

      element.find("tbody").append(
        pagination.closest("tr")
      )
    }
  }

  /**
   *
   * @param control
   * @param pagination
   */
  _set_pagination_style(control, pagination) {
    let ul           = pagination.find("ul");
    let input        = pagination.find(".paginationjs-go-input");
    let button_left  = $(ul.find("li")[0]).clone();
    let button_right = $(ul.find("li")[0]).clone();
    let current_page = control.pagination("getSelectedPageNum");
    let total_pages  = control.pagination("getTotalPage");

    input = input.wrap("<li></li>").parent();
    input.addClass("pull-left float-left").css({"width": "90px"})
         .find("input")
         .addClass("form-control text-center")
         .val(current_page + "/" + total_pages)
         .on("focusout", function () {
           let input = $(this);
           let val   = input.val().split("/")[0];

           input.val(val + "/" + total_pages);
         })
         .on("focusin", function () {
           let input = $(this);

           input.val(input.val().split("/")[0]);

           this.select();
         });

    button_left.attr({"class": "paginationjs-first", "title": "Prima pagina"})
               .removeClass("disabled")
               .find("a").html('<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 448 512"><path d="M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"/></svg>')
               .on("click", function (e) {
                 e.preventDefault();

                 if ($(this).hasClass("disabled")) {
                   return;
                 }

                 control.pagination("1");
               });

    button_right.attr({"class": "paginationjs-last", "title": "Ultima pagina"})
                .removeClass("disabled")
                .find("a").html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="18px"><path d="M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"/></svg>')
                .on("click", function (e) {
                  e.preventDefault();

                  if ($(this).hasClass("disabled")) {
                    return;
                  }

                  control.pagination(total_pages);
                });

    button_left.attr("disabled", current_page === 1)
               .toggleClass("disabled", current_page === 1);

    button_right.attr("disabled", current_page === total_pages)
                .toggleClass("disabled", current_page === total_pages);

    ul.find(".paginationjs-prev").attr("title", "Pagina precedente");
    ul.find(".paginationjs-next").attr("title", "Pagina successiva");

    $(ul.find(".paginationjs-prev")[0]).after(input);

    ul.prepend(button_left);
    ul.append(button_right);
  }

  /**
   * Evento che avviene dopo che si � cliccato sul numero di una pagina.
   *
   * @param {Number} data
   * @param {Object} pagination
   * @param {HTMLElement | jQuery} element
   */
  _on_page_change(data, pagination, element) {
    let current_page, modal_obj;
    let new_url = $.helper.url.create(window.location.toString());

    // Se non esiste un hostname probabilmente lo si sta visualizzando in un iframe creato tramite js, quindi senza url.
    if (!new_url.get_hostname()) {
      return;
  }

    if (this._work_in_modal(element)) {
      modal_obj = this._get_working_modal(element, true);
      new_url   = modal_obj.url;
    }

    current_page = new_url.get_parameter_by_name("page");

    if (pagination.pageNumber !== current_page && pagination.direction !== 0) {
      new_url = new_url.change_parameter_by_name({page: pagination.pageNumber});

      if (modal_obj && modal_obj.initialParms.titolo === 'Elenco errori import') {
        // controllo se siamo in una tab
        if (element.closest('.tab-pane.active')) {
          let tabElement = element.closest('.tab-pane.active');
          this.activeTab = tabElement[0].getAttribute('id');
          // aggiorno l'url inserendo la tab attiva
          current_page = new_url.change_parameter_by_name({"active_tab": this.activeTab});
        }
      }

      if (modal_obj) {
        element.pagination("destroy");
        setTimeout(() => {
          modal_obj.url_parmas = {};
          modal_obj.load_content_from_url(new_url.toString());
        })
      } else {
        $.helper.loading_frame.show();

        window.location = new_url;
      }
    }
  }

  /**
   * Capisce se si sta lavorando in un modale oppure no.
   *
   * @param {HTMLElement | jQuery} element
   * @return {boolean}
   */
  _work_in_modal(element) {
    return this._get_working_modal(element).length > 0;
  }

  /**
   * Ritorna il modale dentro al quale si trova il form su cui si sta lavorando.
   * Se non esiste, ritorna null.
   *
   * @param {HTMLElement | jQuery} element Elemento in base al quale capisce se ci si trova dentro ad un modale.
   * @param {Boolean} [data] Indica se ritornare l'object "modal_popup_obj" anzich� l'elemento html.
   * @return {jQuery | Object}
   */
  _get_working_modal(element, data) {
    if (!(element instanceof jQuery)) {
      element = $(element);
    }

    let modal = element.closest(".modal");

    if (data && modal.length > 0) {
      return modal.data("modal_popup_obj");
    }

    return modal;
  }
}

export default new Pagination();
